import React, { useRef, useState, useEffect } from "react";

const OverlayGallery = (props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      document.querySelector("body").style.overflow = 'hidden'
    } else {
      document.querySelector("body").removeAttribute('style');
    }
  });

  const renderOverlay = () => {
    if (open) {
      return <div className="overlay__background animated fast-1 fadeIn">
        <div className="overlay animated delay-1 fadeInUp--small">
          <div className="overlay__close" onClick={() => setOpen(false)}>
            <div className="budicon-solid solid-budicon-cross-ui"></div>
          </div>
          <div className="container">
            <div className="overlay__content">
              <div className="overlay__content__header">
                <div className="overlay__content__header__title">
                  Video Property Tour
                  </div>
                <div className="overlay__content__header__subtitle">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </div>
              </div>
              <div className="overlay__content__body">
                <div className="overlay__content__body__media">
                </div>
                <div className="overlay__content__body__description">
                  STEPS AWAY FROM Little Trunk Bay, this classic and timeless British colonial beachfront villa has five suites, each furnished with custom-made teak furniture.
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }

  return (
    <div>
      {renderOverlay()}
      <div className="btn btn--square btn--white btn--small btn--abs" onClick={() => setOpen(true)}>
        see all photos
    </div>
    </div>
  )

}

export default OverlayGallery;